import { Helmet } from 'react-helmet-async';

export function NoIndex() {
  return (
    <Helmet>
      <meta id="index__components-seo__meta__l6" name="robots" content="noindex,follow" />
      <meta id="index__components-seo__meta__l7" name="googlebot" content="noindex,follow" />
    </Helmet>);

}